import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import { useTheme } from '@mui/material/styles';

import { useResponsive } from 'src/hooks/use-responsive';

import { bgBlur } from 'src/theme/css';

import { SvgColor } from 'src/components/svg-color';

import AccountPopover from './account-popover';
import { LanguageSwitch } from './language-switch';

import { NAV, HEADER } from '../../config-layout';

// ----------------------------------------------------------------------

type Props = {
  onOpenNav?: VoidFunction;
};

export default function Header({ onOpenNav }: Props) {
  const theme = useTheme();

  const lgUp = useResponsive('up', 'lg');

  return (
    <AppBar
      sx={{
        height: HEADER.H_MOBILE,
        zIndex: theme.zIndex.appBar + 1,
        ...bgBlur({
          color: theme.palette.background.default,
        }),
        transition: theme.transitions.create(['height'], {
          duration: theme.transitions.duration.shorter,
        }),
        ...(lgUp && {
          width: `calc(100% - ${NAV.W_VERTICAL + 1}px)`,
          height: HEADER.H_DESKTOP_OFFSET,
        }),
      }}
    >
      <Toolbar sx={{ height: 1, px: { lg: 2 } }}>
        {!lgUp && (
          <IconButton onClick={onOpenNav}>
            <SvgColor src="/assets/icons/navbar/ic_menu_item.svg" />
          </IconButton>
        )}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: 2,
            flexGrow: 1,
            borderBottom: 'dashed 1px rgba(145, 158, 171, 0.2)',
          }}
        >
          {/* Language Switch */}
          <LanguageSwitch />

          {/* Account Popover */}
          <AccountPopover />
        </Box>
      </Toolbar>
    </AppBar>
  );
}
